import { render, staticRenderFns } from "./TableFilterWrapper.vue?vue&type=template&id=f35c38c2&"
import script from "./TableFilterWrapper.vue?vue&type=script&lang=js&"
export * from "./TableFilterWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports